import React, { useState } from 'react';
import { useAsyncDebounce } from 'react-table';


export const GlobalFilter = ({ filter, setFilter }) => {
    const [value, setValue] = useState(filter)

    const onChange = useAsyncDebounce(value => {
        setFilter(value || undefined)
    }, 300)
    return (
        <span>
            <input className="form-control" style={{width: '500px'}} value={filter || ''}
                onChange={(e) => {
                    setFilter(e.target.value)
                    onChange(e.target.value)
                }} 
                placeholder='Liste durchsuchen'
            />
        </span>
    )
};
